import PageLoaderContainer from './page-loader-container';

/* Usage:
 * Register the plugin on your app:
 *   import Vue from 'vue';
 *   import PageLoader from 'page-loader';
 *
 *   Vue.use(PageLoader);
 *
 * Put the PageLoaderContainer on your root template:
 *   <template>
 *     <page-loader-container />
 *   </template>
 *
 * Then you are ready to use the page-loader:
 * <script>
 * export default {
 *   methods: {
 *     doSomething() {
 *       const myPromise = // some promise
 *       this.$pageLoader.wrap(myPromise)
 *         .then(() => do something here)
 *         .catch(() => and treat the error)
 *     },
 *   },
 * };
 * </script>
 */
let multipleLoaders = false;

const PageLoader = {
  install(Vue) {
    Vue.component('PageLoaderContainer', PageLoaderContainer);

    this.container = undefined;

    Vue.prototype.$pageLoader = {
      setContainer(container) {
        if (PageLoader.container === undefined) {
          PageLoader.container = container;
        } else {
          console.warn('PageLoader component set more than once.');
        }
      },
      show(message) {
        if (PageLoader.container) {
          PageLoader.container.show(message);
        } else {
          throw new Error('You must put a <page-loader-container /> somewhere in your template.');
        }
      },
      hide() {
        if (PageLoader.container) {
          PageLoader.container.hide();
        }
      },
      wrap(promise, message) {
        if (PageLoader.container.visible) {
          multipleLoaders = true;
        }
        this.show(message);
        return promise
          .then(() => {
            if (!multipleLoaders) {
              this.hide();
            }
            multipleLoaders = false;
          })
          .catch((error) => {
            this.hide();
            throw error;
          });
      },
    };
  },
};

export default PageLoader;
